<template>
  <div id="index" class="index mdc-layout-grid mdc-container pt-5 mt-5">
    Prima pagina
  </div>
</template>

<i18n>
{
  "en": {
    "surfverse": "SURFVERSE",
    "about-company": "Founded in 2021 by Bogdan Mateescu, our mission is to empower every startup. By resolving complexity we enable founders to be more productive. By simplifying collaboration we make it easier for teams and investors to work on what matters together.",
    "about": "About Us",
    "workhard": "We’re working hard to build a supportive, welcoming community for founders and Investors alike.",
    "ourmission": "Mission",
    "mission": "We’re on a mission to build the world’s best community for founders and their startups.",
    "mission-desc": "Supporting future entrepreneurs to shape our world.",
    "vision": "Vision",
    "vision-desc": "Simplicity",
    "footer-question": "Founders all over the world work on new products, experiences, and services every day. Come with us.🤙",
    "commit-date": "August 2017",
    "commit": "First commit",
    "word1": "we make problems",
    "word2": "i mean ^1000 we fix bugs",
    "word3": "sometimes ^1000 we solve problems",
    "word4": "i mean",
    "word5": "we make software, ok?"
  },
  "ro": {
    "surfverse": "SURFVERSE",
    "about-company": "Fondată în 2021 de Bogdan Mateescu, misiunea noastră este de a sprijinii fiecare startup. Rezolvând complexitatea, permitem fondatorilor să fie mai productivi. Simplificând colaborarea, facilităm echipele și investitorii să lucreze la ceea ce contează, împreună.",
    "about": "Despre Noi",
    "workhard": "Lucrăm din greu pentru a construi o comunitate de sprijin și primitoare atât pentru fondatori, cât și pentru investitori.",
    "ourmission": "Misiune",
    "mission": "Suntem într-o misiune de a construi cea mai prietenoasă comunitate din lume pentru fondatori și startup-urile acestora.",
    "mission-desc": "Sprijinirea viitorilor antreprenori în călătoria lor de a remodela lumea.",
    "vision": "Viziune",
    "vision-desc": "Simplitatea",
    "footer-question": "Founders all over the world work on new products, experiences, and services every day. Come with us.🤙",
    "commit-date": "August 2017",
    "commit": "Primul commit"
  },
  "de": {
    "surfverse": "SURFVERSE",
    "about-company": "Founded in 2021 by Bogdan Mateescu, our mission is to empower every startup. By resolving complexity we enable founders to be more productive. By simplifying collaboration we make it easier for teams and investors to work on what matters together.",
    "about": "About Us",
    "ourmission": "Mission",
    "mission": "Willkommen bei Surfverse, Startups Secret Launcher.",
    "vision": "Vision",
    "footer-question": "Gründer auf der ganzen Welt arbeiten jeden Tag an neuen Produkten, Erfahrungen und Dienstleistungen. Komm mit uns.🤙",
    "commit-date": "August 2017",
    "commit": "First commit"
  }
}
</i18n>

<style></style>

<script>
export default {
  name: 'Theapp',
  // metaInfo: {
  //   // if no subcomponents specify a metaInfo.title, this title will be used
  //   title: 'About',
  //   // all titles will be injected into this template
  //   titleTemplate: '%s | My Awesome Webapp',
  //   meta: [{ name: 'description', content: '' }]
  // },
  metaInfo() {
    return {
      title: this.$t('title') || 'Default',
      titleTemplate: '%s | Surfverse',
      meta: [{ name: 'description', content: this.$t('description') }]
    }
  }
}
</script>
